// Snowplow data is daily; avoid re-running expensive BigQuery jobs on tab switches.
export const NLS_ANALYTICS_STALE_TIME_MS = 30 * 60 * 1000;

export const nlsAnalyticsQueryOptions = {
  staleTime: NLS_ANALYTICS_STALE_TIME_MS,
  retry: false,
} as const;
